import React from "react";
import { getDateShortcuts, matchShortcut } from "@/lib/dateShortcuts";
import { X } from "@phosphor-icons/react";

/**
 * Compact row of date-range shortcut chips + custom "from"/"to" date inputs.
 * Values are stored as ISO `YYYY-MM-DD` strings so they can be used directly
 * with <input type="date">.
 */
export function DateShortcuts({ from, to, onChange, testId = "date-shortcuts" }) {
  const shortcuts = getDateShortcuts();
  const active = matchShortcut(from, to);

  const pick = (s) => onChange({ from: s.from, to: s.to });
  const clear = () => onChange({ from: "", to: "" });

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex flex-wrap gap-1.5">
        {shortcuts.map((s) => {
          const isActive = active === s.key;
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => pick(s)}
              data-testid={`${testId}-${s.key}`}
              className={`font-mono-data text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-sm border transition-colors ${
                isActive
                  ? "bg-[#0055FF] border-[#0055FF] text-white"
                  : "bg-[#0A0A0A] border-white/10 text-white/60 hover:text-white hover:border-white/30"
              }`}
            >
              {s.label}
            </button>
          );
        })}
        {(from || to) && (
          <button
            type="button"
            onClick={clear}
            data-testid={`${testId}-clear`}
            className="inline-flex items-center gap-1 font-mono-data text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm border border-white/10 text-white/40 hover:text-[#FF3B30] hover:border-[#FF3B30]/40 transition-colors"
            title="Limpiar rango"
          >
            <X size={10} /> Limpiar
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2 max-w-md">
        <div>
          <label className="block text-[10px] font-mono-data uppercase tracking-widest text-white/40 mb-1">
            Desde
          </label>
          <input
            type="date"
            data-testid={`${testId}-from`}
            value={from || ""}
            onChange={(e) => onChange({ from: e.target.value, to })}
            className="w-full px-2 py-1.5 rounded-sm bg-[#0A0A0A] border border-white/10 text-xs text-white focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF] outline-none"
          />
        </div>
        <div>
          <label className="block text-[10px] font-mono-data uppercase tracking-widest text-white/40 mb-1">
            Hasta
          </label>
          <input
            type="date"
            data-testid={`${testId}-to`}
            value={to || ""}
            onChange={(e) => onChange({ from, to: e.target.value })}
            className="w-full px-2 py-1.5 rounded-sm bg-[#0A0A0A] border border-white/10 text-xs text-white focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF] outline-none"
          />
        </div>
      </div>
    </div>
  );
}
